export default "__VITE_ASSET__DxpysTcM__"